import {Grid} from '@mui/material';
import {useNavigate} from 'react-router';
import {UserAccount} from '../../__generated__/resolvers-types';
import {getFeatures} from '../../features';
import FeatureDashboardCard from './FeatureDashboardCard';

export interface FeatureDashboardProps {
  user: UserAccount | null | undefined;
}

export default function FeatureDashboard({user}: FeatureDashboardProps) {
  const navigate = useNavigate();
  const features = getFeatures(user);

  return (
    <Grid container spacing={2} direction="row" wrap="wrap" justifyContent="space-evenly">
      {features.map((feature) => (
        <FeatureDashboardCard
          key={feature.title}
          sx={{width: {xs: '100%', sm: '45%'}}}
          title={feature.title}
          description={feature.description}
          icon={feature.IconComponent}
          status={feature.status}
          onClick={() => navigate(feature.path)}
        />
      ))}
    </Grid>
  );
}
